export enum EPaymentMethod {
    // PAYPAL = 'PAYPAL',
    PAYTM = 'PAYTM',
    RAZORPAY = 'RAZORPAY',
    CASH = 'CASH',
}
